<div class="main-page">
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <div class="logo"><a (click)="redirectTo()"><img src="assets/logo-4.png"></a></div>
  </nav>
  <div class="container">
    <!-- <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader> -->
    <div class="subscription-page-main">
      <div class="subscription-page">
        <div class="container1">
          <div></div>
          <div class="active"></div>
          <div></div>
          <div></div>
        </div>
        <!-- Duration Picker (AddOn Tiers) -->
        <div class="row plan-selection mb-3" *ngIf="addOnPlans && addOnPlans.length > 0">
          <div class="col-12">
            <label><strong>Select Ad Duration:</strong></label>
            <div class="d-flex flex-wrap gap-2">

              <div class="form-check form-check-inline">
                <input type="radio" name="durationOption" id="plan_1week" value="1_WEEK"
                  [checked]="selectedAddOnPlan?.value === '1_WEEK'"
                  (change)="selectStaticDuration('1_WEEK', 'Week', 25)" class="form-check-input">
                <label for="plan_1week" class="form-check-label">1 Week ($25)</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" name="durationOption" id="plan_2weeks" value="2_WEEKS"
                  [checked]="selectedAddOnPlan?.value === '2_WEEKS'"
                  (change)="selectStaticDuration('2_WEEKS', 'Weeks', 40)" class="form-check-input">
                <label for="plan_2weeks" class="form-check-label">2 Weeks ($40)</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" name="durationOption" id="plan_1month" value="1_MONTH"
                  [checked]="selectedAddOnPlan?.value === '1_MONTH'"
                  (change)="selectStaticDuration('1_MONTH', 'Month', 75)" class="form-check-input">
                <label for="plan_1month" class="form-check-label">1 Month ($75)</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" name="durationOption" id="plan_3months" value="3_MONTHS"
                  [checked]="selectedAddOnPlan?.value === '3_MONTHS'"
                  (change)="selectStaticDuration('3_MONTHS', 'Months', 175)" class="form-check-input">
                <label for="plan_3months" class="form-check-label">3 Months ($175)</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" name="durationOption" id="plan_6months" value="6_MONTHS"
                  [checked]="selectedAddOnPlan?.value === '6_MONTHS'"
                  (change)="selectStaticDuration('6_MONTHS', 'Months', 425)" class="form-check-input">
                <label for="plan_6months" class="form-check-label">6 Months ($425)</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" name="durationOption" id="plan_1year" value="1_YEAR"
                  [checked]="selectedAddOnPlan?.value === '1_YEAR'"
                  (change)="selectStaticDuration('1_YEAR', 'Year', 650)" class="form-check-input">
                <label for="plan_1year" class="form-check-label">1 Year ($650)</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row plan-name">
          <div class="price-cust col-md-3">
            <p>${{price}}</p>
          </div>
          <div class="des-h col-md-9">
            <p>{{plan.description}}</p>
          </div>
        </div>
        <div class="horizontally-radio">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"
              (click)="selectType(1)">
            <label class="form-check-label" for="inlineRadio1">Radius</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"
              (click)="selectType(2)">
            <label class="form-check-label" for="inlineRadio2">Area</label>
          </div>
        </div>

        <div *ngIf="loading" style="margin-bottom: 35px;
        ">
          <div style="text-align: -webkit-center;
        ">
            <div class="loader"></div>
          </div>
        </div>


        <div *ngIf="show">
          <div class="select-your-choice" *ngIf="isArea">
            <div class="form-check" *ngFor="let sub of subscriptions?.miles; let i = index">
              <input type="radio" class="form-check-input" name="q" id="milesOption{{i}}" (click)="selectCriteria(sub)">
              <!-- <label class="form-check-label" for="option1">{{subscrption.area}}</label> -->
              <label class="form-check-label" for="milesOption{{i}}">{{sub.miles}} {{sub.type }}</label>
            </div>
          </div>
          <div class="select-your-choice" *ngIf="!isArea">
            <div class="form-check" *ngFor="let subscrption of subscriptions.area; let i = index">
              <input type="radio" class="form-check-input" name="q" id="areaOption{{i}}"
                (click)="selectCriteria(subscrption)">
              <label class="form-check-label" for="areaOption{{i}}">{{subscrption.area | titlecase}}</label>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-md-6">
            <div class="text-c">
              <p (click)="selectOrigin(myModal)">Set ad center point/origin</p>
            </div>
            <div *ngIf="location">{{location}}</div>
          </div>
          <div class="col-md-6">
            <div class="next-button">
              <button type="submit" class="btn btn-primary mb-2 button-c" [disabled]="isSubmitting"
                (click)="checkout()">{{addStatus ? 'Save' : 'Next'}}</button>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>

</div>







<ng-template #myModal let-modal>
  <div class="modal-header">
    <div style="display: flex; justify-content: space-between;">
      <p style="color: #ffff; font-weight: 600;">Set Center Point / Origin Location</p>
      <div class="row">
        <div type="button" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">X</span>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <div class="add-location">
      <input ngx-google-places-autocomplete class="form-control" (onAddressChange)="AddressChange($event)" />
      <!-- <app-auto (setAddress)="AddressChange($event)" [strictBounds]="boundsLimit" [LatLng]="defaultBounds"
        adressType="geocode" title="Name your location"></app-auto> -->

    </div>
    <form class="form-signin" [formGroup]="form">
      <br>
      <div class="custom-control custom-switch">
        <label class="switch-top" for="customSwitch1">Limit results to current region</label>
        <label class="switch">
          <input type="checkbox" (click)="limitCheckbox($event)" checked>
          <span class="slider round"></span>
        </label>
      </div>
      <div class="form-group">
        <input class="form-control" type="text" name="streetAddress" formControlName="streetAddress"
          placeholder="Street Address">
      </div>
      <div class="form-group">
        <input class="form-control" type="text" name="city" formControlName="city" placeholder="City">
      </div>
      <div class="form-group">
        <input class="form-control" type="text" name="state" formControlName="state" placeholder="State">
      </div>
      <div class="form-group">
        <input class="form-control" type="text" name="postalCode" formControlName="postalCode"
          placeholder="Zip/Postal Code">
      </div>
      <div class="form-group">
        <input class="form-control" type="text" name="country" formControlName="country" placeholder="Country">
      </div>
      <button class="btn" type="button" style="margin-right: 5px; float:right;"
        (click)="addAddresses(form.value)">Add</button>
      <!-- <input class="form-control"  type="text" name="pay" formControlName="address_contact_no" placeholder="address_contact_no">
  <input class="form-control"  type="text" name="pay" formControlName="address_alternateContact_no" placeholder="address_alternateContact_no"> -->
      <!-- <div class="icon-size" (click)="removeItem(i)"><i class="del fa fa-trash" aria-hidden="true"></i></div> -->
    </form>


  </div>
</ng-template>

<ng-template #saveLocationModal let-modal>
  <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center;">
    <h4 style="margin: 0;">Save Address</h4>
    <div style="cursor: pointer; color: #fff; font-size: 20px; line-height: 1;" (click)="cancelModal()">
      &times;
    </div>
  </div>
  <div class="modal-body">
    <p>Would you like to save this location</p>
    <form class="form-signin" [formGroup]="form">
      <div class="form-group">
        <input class="form-control" type="text" name="googleAddress" formControlName="googleAddress"
          placeholder="Street Address">
      </div>
      <div class="row pull-right">
        <button class="btn" type="button" style="margin-right: 5px;"
          (click)="changeLocationName(form.value)">Save</button>
        <button class="btn" type="button" style="margin-right: 5px;" (click)="cancelModal()">Cancel</button>
      </div>
    </form>
  </div>
</ng-template>